module.exports = __webpack_public_path__ + "img/auth_hugeboy.03345118.png";